<template>
    <div class="com-item media-text-module" :key="index">
        <div class="component person-nav">
            <div
                class="van-sticky"
                :style="{
                    backgroundColor: modata.WContent.bgColor || 'transparent',
                    backgroundImage: modata.WContent.bgImg ? 'url(' + modata.WContent.bgImg + ')' : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    color: modata.WContent.textColor || '#333'
                }"
            >
                <div class="media-text-module__inner">
                    <template v-if="modata.WContent.showType == 1">
                        <div
                            class="media-text-module__row media-text-module__row--single"
                            :class="{ 'media-text-module__row--reverse': modata.WContent.type1 && modata.WContent.type1.layoutDirection === 'imgLeft' }"
                        >
                            <div class="media-text-module__media">
                                <img
                                    v-if="modata.WContent.type1 && modata.WContent.type1.imgUrl"
                                    :src="modata.WContent.type1.imgUrl"
                                    alt=""
                                />
                            </div>
                            <div class="media-text-module__text">
                                <p class="media-text-module__title">{{ modata.WContent.type1 && modata.WContent.type1.title }}</p>
                                <hr class="media-text-module__line" />
                                <div
                                    class="media-text-module__desc ql-editor"
                                    v-html="modata.WContent.type1 && modata.WContent.type1.textHtml"
                                ></div>
                            </div>
                        </div>
                    </template>

                    <template v-else>
                        <div
                            class="media-text-module__row media-text-module__row--top"
                            :class="{ 'media-text-module__row--reverse': modata.WContent.type2 && modata.WContent.type2.layoutDirection === 'imgLeft' }"
                        >
                            <div class="media-text-module__text">
                                <p class="media-text-module__en" :style="getColor()">{{ modata.WContent.type2 && modata.WContent.type2.enTitle }}</p>
                                <p class="media-text-module__title">{{ modata.WContent.type2 && modata.WContent.type2.cnTitle }}</p>
                                <div
                                    class="media-text-module__desc ql-editor"
                                    v-html="modata.WContent.type2 && modata.WContent.type2.textHtml"
                                    :style="getColor()"
                                ></div>
                            </div>
                            <div class="media-text-module__media">
                                <template v-if="modata.WContent.type2 && modata.WContent.type2.mediaType === 'video' && modata.WContent.type2.videoUrl">
                                    <div class="media-text-module__video-wrap">
                                        <video
                                            ref="video2"
                                            :src="modata.WContent.type2.videoUrl"
                                            :poster="modata.WContent.type2.videoPoster"
                                            :controls="playStatus"
                                            width="100%"
                                            height="100%"
                                        ></video>
                                        <div
                                            v-show="!playStatus"
                                            class="media-text-module__video-mask"
                                            @click="changePlay2"
                                        >
                                            <span class="media-text-module__video-icon">
                                                <i class="el-icon-caret-right" style="font-size: 36px;"></i>
                                            </span>
                                        </div>
                                    </div>
                                </template>
                                <img
                                    v-else-if="modata.WContent.type2 && modata.WContent.type2.mediaType === 'image' && modata.WContent.type2.imgUrl"
                                    :src="modata.WContent.type2.imgUrl"
                                    alt=""
                                />
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "media-text-module",
    components: {},
    props: {
        index: {
            type: Number
        },
        type: {
            type: String,
            default: 'preview'
        },
        isactive: {
            type: Boolean,
            default: false
        },
        phoneWidth: {
            type: Number,
            default: 1280
        },
        proportion: {
            type: Number,
            default: 1
        },
        modata: {
            type: Object,
            default: function() {
                return {
                    WName: 'media-text',
                    Title: '图文混排',
                    MID: 14,
                    WID: null,
                    ModuleName: 'media-text-module',
                    WContent: {}
                }
            }
        }
    },
    data() {
        return {
            playStatus: false
        }
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        getColor() {
            if (this.modata.WContent.bgColor && this.modata.WContent.textColor) {
                return { color: this.modata.WContent.textColor }
            }
            return ''
        },
        changePlay2() {
            if (!this.$refs.video2) return
            if (this.playStatus) this.$refs.video2.pause()
            else this.$refs.video2.play()
            this.playStatus = !this.playStatus
        }
    },
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
.media-text-module {
    .media-text-module__inner {
        width: 90%;
        max-width: 1600px;
        margin: 0 auto;
        box-sizing: border-box;
    }

    .media-text-module__row {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        align-items: center;
        width: 100%;
        box-sizing: border-box;

        &.media-text-module__row--reverse {
            flex-direction: row-reverse;
        }
    }

    .media-text-module__media {
        flex: 1 1 50%;
        max-width: 50%;
        padding: 0 20px;
        box-sizing: border-box;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            border-radius: 10px;
            display: block;
        }
    }

    .media-text-module__text {
        flex: 1 1 50%;
        max-width: 50%;
        padding: 0 20px;
        box-sizing: border-box;
        align-self: center;
    }

    .media-text-module__en {
        font-size: 20px;
        font-family: "PingFang Medium", "pingfang medium", sans-serif;
        color: rgba(1, 79, 164, 1);
        margin: 0 0 8px 0;
        line-height: normal;
    }

    .media-text-module__title {
        font-weight: bold;
        margin: 0 0 12px 0;
        line-height: normal;
    }

    .media-text-module__line {
        border: 0;
        height: 1px;
        background: currentColor;
        opacity: 0.3;
        margin: 0 0 16px 0;
        width: 100%;
    }

    .media-text-module__desc {
        line-height: 1.8;
        margin: 0;

        p { margin: 0 0 8px 0; }
    }

    .media-text-module__row--single {
        padding: 10px 0;

        .media-text-module__title {
            font-size: 30px;
            font-family: "PingFang Heavy", "pingfang heavy", sans-serif;
        }
        .media-text-module__desc {
            font-size: 16px;
            color: rgba(78, 78, 78, 1);
        }
    }

    .media-text-module__row--top {
        padding: 3% 0;

        .media-text-module__title {
            font-size: 42px;
            font-family: "PingFang Heavy", "pingfang heavy", sans-serif;
        }
        .media-text-module__desc {
            font-size: 16px;
            color: rgba(102, 102, 102, 1);
            line-height: 1.7;
        }
    }

    .media-text-module__video-wrap {
        position: relative;
        width: 100%;
        aspect-ratio: 16 / 9;
        background: #000;
        border-radius: 10px;
        overflow: hidden;

        video { width: 100%; height: 100%; display: block; }
    }
    .media-text-module__video-mask {
        position: absolute;
        inset: 0;
        background-color: rgba(255, 255, 255, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .media-text-module__video-icon {
        width: 80px;
        height: 80px;
        background: #fff;
        border-radius: 50%;
        text-align: center;
        box-shadow: 0 0 10px #dedede;
        cursor: pointer;

        i { line-height: 80px; }
    }
}


@media screen and (max-width: 768px) {
   .media-text-module {
    .media-text-module__row--single{
      flex-direction: column;
        
    }
    .media-text-module__title{
        font-size: 26px;
        margin: 12px 0;
    }
    .media-text-module__media,.media-text-module__text{
        flex: 1;
        max-width: 100%;
    }
    .media-text-module__row{
        flex-direction: column;
    }
    .media-text-module__desc{
        margin-bottom: 10px;
    }


   }
   .media-text-module .media-text-module__row.media-text-module__row--reverse{
    flex-direction: column ;
   }

}

</style>
